import { pxToRem } from '../../../../utils';
export var chatItemVariables = function chatItemVariables() {
  return {
    gutterMargin: pxToRem(10),
    gutterMarginCompact: pxToRem(2),
    margin: pxToRem(8),
    messageMargin: pxToRem(40),
    messageMarginCompact: pxToRem(56),
    messageMarginEndCompact: pxToRem(16)
  };
};